import {ApolloClient} from "@apollo/client";
import log from "loglevel";
import {OrderEvent} from "../generated/graphql";
import {buildJobQuery} from "../utils/dynamic-query/job-query-builder";

const NOTES_FIELDS = [
  "order.orderId",
  "order.orderEvents.orderEventId",
  "order.orderEvents.eventDateTime",
  "order.orderEvents.eventType",
  "order.orderEvents.note",
  "order.orderEvents.userId",
  "order.orderEvents.userName"
];

const notesQuery = buildJobQuery(NOTES_FIELDS);

/**
 * Batch-fetch dispatch notes from the jobs OpenSearch index for a set of orderIds.
 * Uses the searchJobs queryString filter to look up multiple orders in one request.
 */
export async function fetchDispatchNotes(
  client: ApolloClient<any>,
  orderIds: number[]
): Promise<Map<number, OrderEvent[]>> {
  const notesMap = new Map<number, OrderEvent[]>();

  if (!orderIds.length) {
    return notesMap;
  }

  const uniqueIds = [...new Set(orderIds)];

  try {
    const res = await client.query({
      query: notesQuery,
      variables: {
        offset: 0,
        limit: uniqueIds.length,
        filter: {
          queryString: {
            fields: ["order.orderId"],
            query: uniqueIds.join(" OR ")
          }
        }
      }
    });

    const items = res.data?.searchJobs?.items ?? [];
    for (const job of items) {
      const orderId = job?.order?.orderId;
      const events = job?.order?.orderEvents ?? [];
      if (orderId != null && events.length > 0) {
        notesMap.set(orderId, events);
      }
    }
  } catch (err) {
    log.error("Failed to fetch dispatch notes from jobs index", err);
  }

  return notesMap;
}
